import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import * as echarts from "echarts";

const FirmwareComplianceChart = ({
  data,
  height = "250px",
  totalLabel = "Total",
  totalValue = 0,
  legendFormatter,
}) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    const chartDom = chartRef.current;
    if (!chartDom) return;

    let chart = echarts.getInstanceByDom(chartDom);
    if (chart) {
      chart.dispose();
    }
    chartDom.innerHTML = '';

    chart = echarts.init(chartDom, null, { renderer: "svg" });
    chartInstance.current = chart;

    const option = {
      tooltip: {
        trigger: "item",
        formatter: "{b}: {c} ({d}%)",
      },
      legend: {
        orient: "vertical",
        left: "35%",
        top: "center",
        selectedMode: true,
        itemGap: 20,
        itemWidth: 10,
        itemHeight: 10,
        icon: "circle",
        textStyle: {
          fontSize: 14,
          color: "#172664",
          rich: {
            name: {
              width: 120,
              fontSize: 14,
              color: "#172664",
            },
            percent: {
              fontSize: 14,
              fontWeight: "bold",
              color: "#172664",
              align: "right",
            },
          },
        },
        formatter: legendFormatter,
      },
      series: [
        {
          type: "pie",
          left: 0,
          top: 0,
          width: "30%",
          height: "100%",
          radius: ["70%", "90%"],
          avoidLabelOverlap: false,
          selectedMode: false,
          cursor: "default",
          itemStyle: {
            borderRadius: 0,
            borderColor: '#fff',
            borderWidth: 2,
          },
          label: {
            show: true,
            position: "center",
            formatter: () => `{desc|${totalLabel}}\n{total|${totalValue}}`,
            rich: {
              total: {
                fontSize: 32,
                fontWeight: "bold",
                color: "#172664",
                lineHeight: 40,
              },
              desc: {
                fontSize: 14,
                color: "#718096",
              },
            },
          },
          emphasis: {
            scale: true,
            scaleSize: 10,
          },
          data: data,
        },
      ],
    };

    chart.setOption(option);

    // 點擊文字放大
    chart.on('legendselectchanged', (params) => {
      chart.dispatchAction({
        type: 'legendSelect',
        name: params.name
      });

      chart.dispatchAction({
        type: 'highlight',
        seriesIndex: 0,
        name: params.name
      });
    });

    const resizeObserver = new ResizeObserver(() => chart.resize());
    resizeObserver.observe(chartDom);

    return () => {
      resizeObserver.disconnect();
      chart.dispose();
    };
  }, [data, totalLabel, totalValue, legendFormatter]);

  return (
    <Box
      ref={chartRef}
      style={{
        width: "100%",
        height,
        background: "#fff",
      }}
    />
  );
};

export default FirmwareComplianceChart;